import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import {
  IError,
  ECreativeStatus,
  EReportColumnHeader,
} from '@unfoldrtech/portal-mic'
import {
  EReportingTimeWindow,
  IReportingCreativesTableResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAAdGroupsCreativesReportTableFilters,
  TDACreativesReportTableFilters,
  TDOOHAdGroupsCreativesReportTableFilters,
  TDOOHCreativesReportTableFilters,
  TPPRetailerId,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetRetailerReportingCreativesTableV3({
  retailerId,
  advertiserId,
  campaignId,
  adGroupId,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (
  | TDACreativesReportTableFilters
  | TDAAdGroupsCreativesReportTableFilters
  | TDOOHCreativesReportTableFilters
  | TDOOHAdGroupsCreativesReportTableFilters
) &
  TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingCreativesTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingCreativesTable_${retailerId}_${advertiserId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, campaignId }],
    () => {
      return coreAPIV3.retailerReporting().getRetailerCreativesReportTableV3(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        campaignId,
        adGroupId,
        sortBy as EReportColumnHeader,
        sortOrder,
        timeWindow as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        pageLimit,
        pageOffset,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status as ECreativeStatus
      )
    },
    { suspense, enabled }
  )
}
